import type { FaireProductEntity } from "../../entity_types/product";

export const p_jvxwdxj6m5: FaireProductEntity = {
  token: "p_jvxwdxj6m5",
  type: "product",
  name: "Oatmeal Honey Starter Set: Lip Balm, Bar Soap & Body Butter",
  brandToken: "b_a845a903",
  brandName: "Spinster Sisters Co. / Old Salt Grooming Supply",
  imageUrl:
    "https://cdn.faire.com/fastly/d2d73a2acb0a2291e36d2a59daadf0f3fd8a0b031ca64042a82d0034bb35a28a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c029319bf7cbba71f6de14e42789fcd6ea1ff9c0aa678a194f4baca64ea7562c.png",
    "https://cdn.faire.com/fastly/6bec16be94cc5510a3ff5435041951b187ef39389f5877f2be5ee051ebd8619b.png",
    "https://cdn.faire.com/fastly/42ac55bf52edac108adf3dfde7cf2833af61bd4d5ebda624ab82af04b761ad8b.png",
  ],
  priceDollars: 12.6,
  description:
    "Oatmeal Honey Starter Set is the perfect bath and body gift collection designed to bring warmth and comfort to any occasion. This thoughtfully curated set includes a natural lip balm, a moisturizing bar soap, and a creamy body butter, all infused with the delightful scent of oatmeal milk and honey. \n\nIdeal for effortless gifting, this sampler set ensures a soothing experience that nourishes the skin.\n\n* Includes three products: lip balm, bar soap, and body butter\n* Infused with the cozy aroma of oatmeal milk and honey\n* Crafted with plant-based ingredients for gentle skin care\n* Eco-friendly packaging supports sustainable gifting\n* Cruelty-free and carbon-neutral commitment for ethical skincare\n\nA wonderful addition to any retailer’s eco-conscious product line, this Oatmeal Honey Starter Set provides a luxurious, ready-to-gift option that delights customers seeking relaxation and nourishment in their skincare routines. ",
  tags: [],
  msrpDollars: 25.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:04.991Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
